import "../App.css";

export default function NotFound() {
  return (
    <div className="NotFound">
      <img className="notFoundImage" src="not-found.webp" alt="Page not found" />
      <div className="lander">
        <h1>Page not found</h1>
        <p className="text-muted">Invalid url or version parameter provided</p>
      </div>
    </div>
  );
}
